export const isNumber = (value: any): value is number => typeof value === 'number';

export const isString = (value: any): value is string => typeof value === 'string';

export const isBoolean = (value: any): value is boolean => typeof value === 'boolean';

export const isObject = (value: any): value is Record<string, any> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

export const isArray = (value: any): value is any[] => Array.isArray(value);

export const isUndefined = (value: any): value is undefined => value === undefined;

export const isNull = (value: any): value is null => value === null;

export const isFunction = (value: any): value is Function => typeof value === 'function';

export const isDate = (value: any): value is Date => value instanceof Date;

export const isSymbol = (value: any): value is symbol => typeof value === 'symbol';

export const isBigInt = (value: any): value is bigint => typeof value === 'bigint';

export const isOptionalString = (value: any): value is string | undefined => {
  return value === undefined || isString(value);
};

export const isOptionalBoolean = (value: any): value is boolean | undefined => {
  return value === undefined || typeof value === 'boolean';
};
